import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ProgressBar from './ProgressBar';

import './GCDWidget.scss';

const GCDWidget = ({ pldDiscountBuckets }) => {
  let GCDtext;
  let GCDValue;
  let GCDProgressBarPercentage = 0;

  const numOfThresholds = pldDiscountBuckets.length;
  const allUnlocked = pldDiscountBuckets[numOfThresholds - 1].isUnlocked;

  if (allUnlocked) {
    GCDtext = 0;
    GCDValue = pldDiscountBuckets[numOfThresholds - 1].discountPercent;
    GCDProgressBarPercentage = 300;
  } else {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < pldDiscountBuckets.length; i++) {
      if (!pldDiscountBuckets[i].isUnlocked) {
        GCDtext = pldDiscountBuckets[i].extraMrpRequired;
        GCDValue = pldDiscountBuckets[i].discountPercent;
        GCDProgressBarPercentage += pldDiscountBuckets[i].progressBarPercentage;
        break;
      } else {
        GCDProgressBarPercentage += 100;
      }
    }
  }

  return (<div className="GCDContainer">
    <div className="GCDDetailContainer">
      {allUnlocked ?
        <div className="GCDDetailText">
            Woohoo! You are saving <span className="bold">{GCDValue}%</span> on this order
        </div> :
        <div className="GCDDetailText">
            Add items worth <span className="bold">₹{GCDtext}</span> to unlock{' '}
          <span className="bold">{GCDValue}% OFF</span>
        </div>
      }

      <ProgressBar
        currentSaving={GCDProgressBarPercentage / 3}
        totalSaving={100}
      />
      <div className="progressBarSection">
        {pldDiscountBuckets.map((discountBucket, index) => (
          <div
            key={index}
            className={
                  pldDiscountBuckets.length === 3
                    ? 'progressBar3'
                    : 'progressBar2'
                }
          >
            <div className="vl" />
            <div className="progressDetail">
              {discountBucket.isUnlocked ? (
                <img
                  src="https://assets.pharmeasy.in/web-assets/images/greenUnlockIcon.svg"
                  alt="red_lock_icon"
                  width={16}
                  height={16}
                />
                    ) : (
                      <img
                        src="https://assets.pharmeasy.in/web-assets/images/redLockIcon.svg"
                        alt="red_lock_icon"
                        width={16}
                        height={16}
                      />
                    )}
              <div
                className={cx('discountPercent', { discountPercentUnlocked: discountBucket.isUnlocked })}
              >
                {`${discountBucket.discountPercent}% OFF`}&nbsp;
              </div>
              <div
                className="cartValue"
              >
                @ {`₹${discountBucket.cartValue}`}
              </div>
            </div>
          </div>
            ))}
      </div>
    </div>
  </div>);
};

GCDWidget.propTypes = {
  pldDiscountBuckets: PropTypes.array,
};

GCDWidget.defaultProps = {
  pldDiscountBuckets: [],
};

export default GCDWidget;

